import { render } from "./UnitChip.vue?vue&type=template&id=4de5f9c6&scoped=true"
import script from "./UnitChip.vue?vue&type=script&lang=js"
export * from "./UnitChip.vue?vue&type=script&lang=js"

import "./UnitChip.vue?vue&type=style&index=0&id=4de5f9c6&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de5f9c6"]])

export default __exports__